
import AbstractSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/abstract-symbol-behaviour";

export default class DimSymbolBehaviour extends AbstractSymbolBehaviour {

    public static() {
        super.static();

        this.symbol.tint(0xffffff);
    }

    public win() {
        this.symbol.tint(0xffffff);

        return super.win();
    }

    public cycle() {
        this.symbol.tint(0xffffff);

        return super.cycle();
    }

    public dim() {
        this.symbol.tint(0x333333);
        return super.dim();
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/matrix/symbol/behaviours/dim-symbol-behaviour.ts